import styled from 'styled-components'

import {Container} from '../general/container/Container'

export const SelectWrapper = styled(Container)`
  max-width: 600px;
  margin-top: ${({theme}) => theme.spacing.xxl};
`
